import { cellErrors } from "@/react/components/table/useTableMutations";
import { EditableBooleanCell } from "@/react/components/table/components/cells";
import ValidationWrapper from "@/react/components/table/components/ValidationWrapper";
import Tooltip from "@8x8/oxygen-tooltip";
import { InfoCircleIcon } from "@8x8/oxygen-icon";
import { color } from "@8x8/oxygen-constants";
import { SideBySideDivs } from "@/react/features/styled/SideBySideDivs";

const TooltipContent = () => (
  <>
    <div>
      Disabling an active member will trigger a delete operation on the specific
      member after clicking the Save button.
    </div>
    <div>Enabling a non existing member will trigger a create operation.</div>
  </>
);

const MemberExistsCell = (cellProps) => {
  const errors = cellErrors(cellProps);
  return (
    <ValidationWrapper errors={errors}>
      <SideBySideDivs>
        <Tooltip title={<TooltipContent />}>
          <InfoCircleIcon color={color.dodgerBlue} />
        </Tooltip>
        <EditableBooleanCell {...cellProps} />
      </SideBySideDivs>
    </ValidationWrapper>
  );
};

export default MemberExistsCell;
